import React, { useState, useEffect, useRef } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from '../axios';
import BreadcrumbBg from '../img/banner/breadcrumb-bg.jpg'
import HeaderSecond from '../HeaderSecond';
import LoaderImg from '../img/logo/running.gif';
import Footer from '../Footer';

const Sitemap = () => {
  // console.log("Create Event page");
  const navigate = useNavigate();
  const [EventDetails, setEventDetails] = useState([]);
  const [CityEventDetails, setCityEventDetails] = useState([]);
  const [Loader, setLoader] = useState(false);
  const [SitemapFlag, setSitemapFlag] = useState(false);
  const mainUrlLink = window.location.origin;
  const hasCalled = useRef(false);

  const handleBackToHome = () => {
    localStorage.removeItem('EventViewFlag');
    localStorage.removeItem('EventDetailsId');

    const CountryCode = localStorage.getItem('CountryCode');
    const CountryName = localStorage.getItem('Country');
    navigate('/' + CountryCode + '/' + CountryName);
  }

  useEffect(() => {
    const UrlLink = window.location.origin;
    window.scrollTo(0, 0);
    setLoader(true);
    axios.post("get_seo_category_events",{'url_link': UrlLink})
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          setEventDetails(response.data.data.category_data);
          setCityEventDetails(response.data.data.city_data);
          setSitemapFlag(true);
        }
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      })
  }, [])

//  useEffect(() => {
//   if (!SitemapFlag) return;

//   // Prevent duplicate calls
//   if (hasCalled.current) return;
//   hasCalled.current = true;

//   setLoader(true);

//   axios.get("/sitemap")
//     .then((response) => {
//       // console.log("Sitemap API called");
//     })
//     .catch((error) => {
//       console.error(error);
//     })
//     .finally(() => {
//       setLoader(false);
//       setSitemapFlag(false);
//       hasCalled.current = false; // 🔥 IMPORTANT
//     });

// }, [SitemapFlag]);
  // console.log(EventDetails);

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
     {Loader ? <div><div id='loader' style={{ backgroundImage: `url(${LoaderImg})` }}></div></div> : null}
      <ToastContainer theme="colored" />

      <HeaderSecond />
      <main className="main__content_wrapper">
        {/* Start breadcrumb section */}
        <section className="breadcrumb__section breadcrumb__bg" style={{ backgroundImage: `url(${BreadcrumbBg})` }} >
          <div className="container">
            <div className="row row-cols-1">
              <div className="col">
                <div className="breadcrumb__content">
                  <h1 className="breadcrumb__content--title text-white mb-10">
                    Sitemap
                  </h1>
                  {/* <ul className="breadcrumb__content--menu d-flex">
                    <li className="breadcrumb__content--menu__items">
                      <div className="text-white" onClick={(e) => handleBackToHome(e)}>
                        Home
                      </div>
                    </li>
                    <li className="breadcrumb__content--menu__items">
                      <span className="text-white">Search Engine Optimization</span>
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End breadcrumb section */}

        <section className="section--padding pt-5">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 my-5" style={{ textAlign: "justify" }}>
                
                <div className="sitemap">
                  {/* Home Section */}
                  <div className="sitemap-section mb-3">
                    <h4>
                      <a href="/" className="text-decoration-none text-dark fw-bold">
                        Home
                      </a>
                    </h4>
                  </div>

                  {/* Dynamic Category Sections */}
                  {EventDetails && Object.keys(EventDetails).map((category) => (
                    <div className="sitemap-section mb-4" key={category}>
                      <h4 className="text-secondary">{category}</h4>
                      <ul className="list-unstyled ms-3">
                        {EventDetails[category].map((event) => (
                          <li key={event.id} className="mb-2">
                             <a
                              href={event.other_platform == 0 ? `${mainUrlLink}/e/${event.event_name_link}` : `${event.other_platform_url}`}
                              className="text-decoration-none text-dark"
                              target='_blank'
                            >
                              {event.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}

                  <br />
                  <hr />
                  <br />

                  {/* Dynamic City Sections */}
                  {CityEventDetails && Object.keys(CityEventDetails).map((city) => (
                    <div className="sitemap-section mb-4" key={city}>
                      <h4 className="text-secondary">{city}</h4>
                      <ul className="list-unstyled ms-3">
                        {CityEventDetails[city].map((item) => (
                          <li key={item.id} className="mb-2">
                             <a
                              href={`${mainUrlLink}/in/${item.city_name}`}
                              className="text-decoration-none text-dark"
                              target='_blank'
                              onClick={(e) => {
                                localStorage.setItem("CityId", item.city);
                              }}
                            >
                              {item.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}

                </div>

              </div>
            </div>

          </div>
        </section>

      </main >
      <Footer />
    </>
  )
}

export default Sitemap;

